import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@rq-ratings/pro-solid-svg-icons'
import classNames from 'classnames'
import React, { ReactNode } from 'react'
import { Alert, OverlayTrigger, Tooltip } from 'react-bootstrap'

interface Props {
  children: ReactNode
  isCurrent?: boolean
  tooltipText?: string
}

const ConnectedAccountAlert: React.FC<Props> = ({
  children,
  isCurrent = false,
  tooltipText = null,
}) => {
  return (
    <OverlayTrigger
      overlay={
        tooltipText ? (
          <Tooltip>
            This is how your personal comms will be sent. To send via your
            company's shared email instead, disconnect this email account.
          </Tooltip>
        ) : (
          <></>
        )
      }
    >
      <Alert
        className={classNames('p-3 mb-0 align-self-stretch', {
          'border-3 border-primary': isCurrent,
        })}
        variant="success"
      >
        <FontAwesomeIcon
          icon={faCircleCheck}
          className="me-2 text-success fs-3"
        />
        {children}
      </Alert>
    </OverlayTrigger>
  )
}

export default ConnectedAccountAlert
